"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Button = _interopRequireDefault(require("../Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var ButtonSegment =
/** @class */
function (_super) {
  __extends(ButtonSegment, _super);

  function ButtonSegment(opts) {
    var _this = this;

    if (opts.value === 'all') {
      opts.multiselect = false;
    }

    _this = _super.call(this, opts) || this;
    return _this;
  }

  Object.defineProperty(ButtonSegment.prototype, "identifier", {
    get: function () {
      return "" + (this.parentId ? this.parentId + "::" : '') + (this.groupId ? this.groupId + "::" : '') + this.id;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ButtonSegment.prototype, "parentId", {
    get: function () {
      return this.opts.parent;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ButtonSegment.prototype, "groupId", {
    get: function () {
      return this.opts.group;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ButtonSegment.prototype, "multiselect", {
    get: function () {
      return this.opts.multiselect;
    },
    enumerable: false,
    configurable: true
  });

  ButtonSegment.prototype._render = function (data) {
    return "\n\t\t\t<li>" + this.title + "</li>\n\t\t";
  };

  return ButtonSegment;
}(_Button.default);

var _default = ButtonSegment;
exports.default = _default;
module.exports = exports.default;